import { Box, Typography, styled } from '@material-ui/core';

export const ContentContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minHeight: '100vh',
});

export const ErrorText = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  fontSize: 14,
  marginTop: 8,
}));

export const CodeInputContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  gap: 12,
  marginBottom: 8,
});

export const CodeInput = styled('input')(({ theme }) => ({
  width: 48,
  height: 56,
  fontSize: 24,
  fontWeight: 500,
  textAlign: 'center',
  border: 'none',
  borderBottom: `2px solid ${theme.palette.text.primary}`,
  outline: 'none',
  backgroundColor: 'transparent',
  transition: 'border-color 0.2s',
  '&:focus': {
    borderBottomColor: theme.palette.primary.main,
  },
  '&.error': {
    borderBottomColor: theme.palette.error.main,
  },
}));
